/* Cart peek — one quiet, consistent "it worked" for every ajax add-to-cart.
   A small card slides up bottom-right: check, item line, View cart /
   Checkout. Replaces the old bootstrap-notify banner for successful adds
   (quickview.js hands off here when window.xgCartPeek exists; failures keep
   the loud center toast). Worker-rendered strips (New Today, card scanner)
   call window.xgCartPeek directly after their own fetch adds.
   Colors ride the xg tokens, so the dark-mode token flip restyles it free. */
(function () {
  if (window.xgCartPeek) return;

  var css = '' +
    '#xg-peek{position:fixed;right:16px;bottom:calc(16px + env(safe-area-inset-bottom,0px));z-index:100002;' +
      'width:min(340px,calc(100vw - 24px));pointer-events:none;font-family:var(--xg-font-body,"Inter",sans-serif)}' +
    '#xg-peek .xg-peek__card{pointer-events:auto;display:flex;gap:10px;align-items:flex-start;' +
      'background:var(--xg-surface,#fff);color:var(--xg-text,#3d454b);border:1px solid var(--xg-border,#e3e6e8);' +
      'border-left:4px solid var(--xg-success,#17784a);border-radius:12px;padding:12px 12px 10px;' +
      'box-shadow:0 12px 34px rgba(16,24,40,.22);opacity:0;transform:translateY(12px);' +
      'transition:opacity 180ms ease,transform 180ms ease}' +
    '#xg-peek.is-open .xg-peek__card{opacity:1;transform:translateY(0)}' +
    '#xg-peek .xg-peek__thumb{width:40px;height:56px;object-fit:cover;border-radius:6px;background:var(--xg-bg,#eef0f2);flex:0 0 40px}' +
    '#xg-peek .xg-peek__body{min-width:0;flex:1 1 auto}' +
    '#xg-peek .xg-peek__head{font-size:13px;font-weight:700;color:var(--xg-success,#17784a);letter-spacing:.02em}' +
    '#xg-peek .xg-peek__title{font-size:13.5px;font-weight:600;color:var(--xg-ink,#171b1d);margin:2px 0 1px;' +
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '#xg-peek .xg-peek__meta{font-size:12px;color:var(--xg-muted,#707a83)}' +
    '#xg-peek .xg-peek__actions{display:flex;gap:8px;margin-top:8px}' +
    '#xg-peek .xg-peek__go{display:inline-block;padding:7px 14px;border-radius:8px;font-size:12.5px;font-weight:700;' +
      'text-decoration:none;background:var(--xg-red,#d62c28);color:#fff}' +
    '#xg-peek .xg-peek__go:hover{background:var(--xg-red-hover,#b3211e);color:#fff}' +
    '#xg-peek .xg-peek__alt{display:inline-block;padding:7px 12px;border-radius:8px;font-size:12.5px;font-weight:600;' +
      'text-decoration:none;color:var(--xg-ink,#171b1d);border:1px solid var(--xg-border,#d7dbdf)}' +
    '#xg-peek .xg-peek__alt:hover{border-color:var(--xg-red,#d62c28);color:var(--xg-red,#d62c28)}' +
    '#xg-peek .xg-peek__x{flex:0 0 auto;width:22px;height:22px;border:0;border-radius:50%;padding:0;cursor:pointer;' +
      'background:transparent;color:var(--xg-muted,#8a9299);font-size:16px;line-height:1}' +
    '#xg-peek .xg-peek__x:hover{color:var(--xg-red,#d62c28)}' +
    '@media (prefers-reduced-motion:reduce){#xg-peek .xg-peek__card{transition:none;transform:none}}' +
    // This <style> lands after the xg-dark.css link, so dark fixes for the
    // low-contrast red-as-text hover live here, not there. Keyed on the
    // toggle's attribute, same as every xg-dark.css rule.
    'html[data-xg-theme="dark"] #xg-peek .xg-peek__alt:hover{border-color:#ff6a5e;color:#ff6a5e}' +
    'html[data-xg-theme="dark"] #xg-peek .xg-peek__x:hover{color:#ff6a5e}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var host = null, timer = null;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function money(cents) {
    if (typeof cents !== 'number' || !(cents >= 0)) return '';
    try {
      if (window.Shopify && Shopify.formatMoney && Shopify.money_format) {
        // formatMoney returns markup-free text for the standard formats
        return String(Shopify.formatMoney(cents, Shopify.money_format)).replace(/<[^>]*>/g, '');
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }
  function build() {
    if (host) return host;
    host = document.createElement('div');
    host.id = 'xg-peek';
    host.setAttribute('role', 'status');
    host.setAttribute('aria-live', 'polite');
    document.body.appendChild(host);
    host.addEventListener('mouseenter', function () { if (timer) { clearTimeout(timer); timer = null; } });
    host.addEventListener('mouseleave', function () { arm(); });
    return host;
  }
  function arm() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { host.classList.remove('is-open'); }, 4500);
  }

  /* d: { title, image, url, qty, cents } — every field optional. */
  function show(d) {
    d = d || {};
    var h = build();
    var qtyBit = d.qty > 1 ? d.qty + ' × ' : '';
    var priceBit = money(d.cents);
    h.innerHTML =
      '<div class="xg-peek__card">' +
        (d.image ? '<img class="xg-peek__thumb" src="' + esc(d.image) + '" alt="">' : '') +
        '<div class="xg-peek__body">' +
          '<div class="xg-peek__head">✓ Added to cart</div>' +
          (d.title ? '<div class="xg-peek__title">' + esc(d.title) + '</div>' : '') +
          (priceBit ? '<div class="xg-peek__meta">' + esc(qtyBit + priceBit) + '</div>' : '') +
          '<div class="xg-peek__actions">' +
            '<a class="xg-peek__go" href="/cart">View cart</a>' +
            '<a class="xg-peek__alt" href="/checkout">Checkout</a>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="xg-peek__x" aria-label="Dismiss">&times;</button>' +
      '</div>';
    h.querySelector('.xg-peek__x').addEventListener('click', function () {
      h.classList.remove('is-open');
      if (timer) { clearTimeout(timer); timer = null; }
    });
    // restart the entrance when peeks come back-to-back
    h.classList.remove('is-open');
    void h.offsetWidth;
    h.classList.add('is-open');
    arm();
  }

  window.xgCartPeek = show;
  document.addEventListener('xg:cart:added', function (e) { show((e && e.detail) || {}); });
})();
